var p={M:"6px",L:"8px",XL:"12px"};export{p as default};
